var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "input input--select" },
    [
      _c("v-select", {
        attrs: {
          options: _vm.options,
          clearable: false,
          placeholder: _vm.defaultOption,
          value: _vm.currentOption,
        },
        on: { input: _vm.handleChange },
      }),
      _vm.mobile
        ? _c("icon", { attrs: { name: "chevron-down", size: "15px" } })
        : _vm._e(),
      _vm.mobile
        ? _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.currentValue,
                  expression: "currentValue",
                },
              ],
              attrs: { disabled: _vm.disabled },
              on: {
                change: function ($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function (o) {
                      return o.selected
                    })
                    .map(function (o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.currentValue = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                },
              },
            },
            [
              !_vm.required
                ? _c("option", { attrs: { value: "" } }, [
                    _vm._v(_vm._s(_vm.defaultOption)),
                  ])
                : _vm._e(),
              _vm._l(_vm.options, function (option) {
                return _c(
                  "option",
                  { key: option.value, domProps: { value: option.value } },
                  [_vm._v(_vm._s(option.label))]
                )
              }),
            ],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }